<div  *ngIf="!errorMsg"  class="w-100 graph" style="overflow: hidden" #graph></div>
<h1 *ngIf="errorMsg" class="text-center q-c-light-main q-font"><i class="fas fa-chart-bar"></i>{{errorMsg}}</h1>


